var mapEnvironmentToAudience = function (environment) {
    switch (environment) {
        case 'bfprod':
        case 'tbprod':
        case 'pfprod':
        case 'prodprv':
        case 'prod':
            return 'Production';
        case 'ppe':
        case 'ppeprv':
            return 'Staging';
        case 'sdf':
            return 'Dogfood';
        case 'dev':
        case 'developer':
        case 'test':
        default:
            return 'Local';
    }
};
var bootIdCount = 0;
/**
 * Implementation of HostContext interface required by Fluid host UX.
 * A new instance of this class should be created for each Fluid document editing session.
 */
var FluidHostContext = /** @class */ (function () {
    /**
     * Constructor
     * @param componentContext the current @see OfficeComponentContext
     * @param identity the identity of the current user
     * @param hostScenarioName the scenario name to use for telemetry
     */
    function FluidHostContext(componentContext, identity, hostScenarioName) {
        if (hostScenarioName === void 0) { hostScenarioName = ''; }
        this.componentContext = componentContext;
        this.identity = identity;
        this.hostScenarioName = hostScenarioName;
        // provide a unique correlation id for host context
        this.bootId = bootIdCount++;
    }
    Object.defineProperty(FluidHostContext.prototype, "HostContext", {
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FluidHostContext.prototype, "audience", {
        get: function () {
            var _a;
            var url = new URL(window.location.href);
            if ((_a = url.searchParams.get('flight')) === null || _a === void 0 ? void 0 : _a.includes('localbundles')) {
                // If we're using the localbundles flight to develop, audience should be Local.
                return 'Local';
            }
            return mapEnvironmentToAudience(this.componentContext.deploymentEnvironment);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FluidHostContext.prototype, "environment", {
        get: function () {
            return getEnvironmentFromAudience(this.audience);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FluidHostContext.prototype, "hostAppName", {
        get: function () {
            return 'Office.com';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FluidHostContext.prototype, "hostAppVersion", {
        get: function () {
            return "".concat(this.componentContext.buildVersion);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FluidHostContext.prototype, "hostAppPlatform", {
        get: function () {
            return 'Web';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FluidHostContext.prototype, "hostCorrelationId", {
        get: function () {
            return "".concat(this.componentContext.correlationId, ".").concat(this.bootId);
        },
        enumerable: false,
        configurable: true
    });
    FluidHostContext.prototype.getBootId = function () {
        return this.bootId;
    };
    Object.defineProperty(FluidHostContext.prototype, "hostSessionId", {
        get: function () {
            var _a;
            return (_a = this.componentContext.correlationId) !== null && _a !== void 0 ? _a : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FluidHostContext.prototype, "hostName", {
        get: function () {
            return 'Office.com';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FluidHostContext.prototype, "userContext", {
        get: function () {
            var _a, _b, _c;
            return {
                user: {
                    oid: (_a = this.identity) === null || _a === void 0 ? void 0 : _a.puid,
                    tenantId: (_c = (_b = this.identity) === null || _b === void 0 ? void 0 : _b.tenantId) !== null && _c !== void 0 ? _c : '',
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    return FluidHostContext;
}());
export { FluidHostContext };
function getEnvironmentFromAudience(audience) {
    switch (audience) {
        case 'Automation':
        case 'SyntheticTraffic':
        case 'Local':
            return {
                audience: audience,
                ring: 'Prod',
            };
        default:
            return { audience: audience };
    }
}
//# sourceMappingURL=fluidHostContext.js.map